import { useLocation, useSearch } from 'wouter';

import { useRequestBase } from '../contexts/RequestContext';

function useCurrentUrl({ withSearch = false } = {}) {
    const baseUri = useRequestBase();
    const [routeLocation] = useLocation();
    const search = useSearch();
    return `${baseUri}${routeLocation}${withSearch ? `?${search}` : ''}`;
}

export default useCurrentUrl;
